import { Component, ViewChild } from '@angular/core';
import { AlertController, App, Events, Nav, Platform, ToastController, MenuController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { DatePipe } from '@angular/common';


import * as firebase from 'firebase';

import { OneSignal } from '@ionic-native/onesignal';
// import { Geolocation } from '@ionic-native/geolocation';
import { ApiProvider } from '../providers/api/api';
import { HttpClient } from '@angular/common/http';
import { CertifyingagencyPage } from '../pages/certifyingagency/certifyingagency';

import { timer } from 'rxjs/observable/timer';

const config = {
  apiKey: 'AIzaSyAYpgIGKfXPLNV5oeM-8iso5o-VLmU_rw0',
  authDomain: 'hscodes2022march.firebaseapp.com',
  databaseURL: 'https://hscodes2022march-default-rtdb.firebaseio.com',
  projectId: 'hscodes2022march',
  storageBucket: 'hscodes2022march.appspot.com',
};



@Component({
  selector: 'app',
  templateUrl: 'app.html'
})
export class MyApp {
  country_code: any; attempt: any;
  @ViewChild(Nav) nav: Nav;
  rootPage: any;
  showSplash = true;
  // rootPage: any = TabsPage; 
  // SDK_KEY: string = "mSguJ2vDfx0cXcZBJ8qBtSgWBzJfKDzGxn1S";
  // SDK_SECRET: string = "dmJnqQEwOK8VIp1prgt4MwZOZmcP28h0qdAK";
  pages: Array<{ title: string, component: any, icon: any }>;
  lat: any;
  lng: any;
  showedAlert: boolean;
  currentaddr: any = {};
  count: any;
  currentdate: any;
  package_name: number = 0;
  country: any;
  confirmAlert: any;
  geo_country_id: any;
  ip_address: any; profiledetails: any; getdata: any;
  // private geolocation: Geolocation,
  constructor(private menu: MenuController, private datePipe: DatePipe, private toastCtrl: ToastController, public app: App, private events: Events, public platform: Platform, public statusBar: StatusBar, public splashScreen: SplashScreen, private alertCtrl: AlertController, private oneSignal: OneSignal, private apiProvider: ApiProvider, private http: HttpClient) {
    this.initializeApp();
    this.menu.enable(true);
    var myDate: String = new Date().toISOString();
    this.currentdate = this.datePipe.transform(myDate, 'yyyy-MM-dd');
    console.log(this.currentdate);

    events.subscribe('user:signedIn', (userEventData) => {
      console.log(userEventData);

      this.profiledetails = userEventData[0];
      console.log(this.profiledetails);

      var usrData = userEventData[0].reportdata.filter(word => word.chapterend >= this.currentdate);
      console.log(usrData);
      if (usrData.length != 0) {
        console.log(usrData);
        var array3 = usrData.map(obj => obj.package_indicator).sort()
        console.log(array3);
        this.package_name = array3[0];

      }
      console.log(this.package_name);

    });


    if (JSON.parse(localStorage.getItem('user_data'))) {

      this.getdata = JSON.parse(localStorage.getItem('user_data'));
      // var userData = JSON.parse(localStorage.getItem('user_data'));
      // console.log(userData);
      if (this.getdata.role != 'AGENT') {
        var usrData = this.getdata[0].reportdata.filter(word => word.chapterend >= this.currentdate);
        console.log(usrData);
        if (usrData.length != 0) {
          console.log(usrData);
          var array3 = usrData.map(obj => obj.package_indicator).sort()
          console.log(array3);
          this.package_name = array3[0];

        } else {
          this.package_name = 0;
        }
        this.profiledetails = this.getdata[0];
        console.log(this.profiledetails);

        console.log(this.profiledetails);
      } else {
        this.profiledetails = JSON.parse(localStorage.getItem('user_data'));
      }
    } else {
      this.profiledetails = [];
    }



    // used for an example of ngFor and navigation

    this.pages = [
      { title: 'About', component: 'AboutusPage', icon: 'custom-about' },
      { title: 'Home', component: 'HomePage', icon: 'custom-home' },
      { title: ' Search ', component: 'SearchPage', icon: 'custom-search' },
      { title: ' Profile ', component: 'ProfilePage', icon: 'custom-profile' },
      { title: ' HS-CRM  ', component: 'HscrmPage', icon: 'custom-crm' },
      { title: ' Favourites  ', component: 'FavouritePage', icon: 'custom-fav' },
      { title: '  Notifications  ', component: 'NotificationsPage', icon: 'custom-notify' },
      { title: ' Request Franchise', component: 'FranchiseRequestPage', icon: 'custom-franchise' },
      { title: ' WEF - Agent Request Form', component: 'AgencyRequestPage', icon: 'custom-agency' },
      // { title: ' Purchases ', component: 'PurchasePage', icon: 'custom-purs' },
      { title: ' Buyer ', component: 'BuyersPage', icon: 'custom-buyer' },
      // { title: '  RFQ - Request For Quote ', component: RfqBucketPage, icon: 'custom-rfq' },
      { title: ' Subscription ', component: 'SubscriptionPage', icon: 'custom-subscription' },
      { title: ' Service Subscription ', component: 'ServicesubscriptionPage', icon: 'custom-subscription' },

      { title: ' Users Location On Map ', component: 'MapsPage', icon: 'custom-map' },
      { title: ' App Demo Videos ', component: 'VideoPage', icon: 'custom-video' },
      // { title: 'SVR-Toolkit', component: 'ToolkitPage', icon: 'custom-toolkit' },
      { title: 'SVR TOOLKIT', component: 'LoginPage', icon: 'custom-toolkit' },
      { title: 'Contact Us', component: 'ContactusPage', icon: 'custom-contact' },
      // { title: 'Downloads', component: 'DownloadPage', icon: 'custom-dnld' },
      { title: 'Terms & Condition', component: 'TermsPage', icon: 'custom-dnld' },
    ];
    // let srvcUsr = JSON.parse(localStorage.getItem('user_data'));
    // if (srvcUsr) {
    //   if (srvcUsr.length > 0) {
    //     if (srvcUsr[0].bestknown == "Service Provider") {
    //       const newdt = { title: ' Service Subscription ', component: 'ServicesubscriptionPage', icon: 'custom-subscription' };
    //       this.pages.splice(11, 0, newdt);
    //     }
    //   }
    // }
    // SearchPage





  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.

      this.statusBar.styleDefault();
      this.splashScreen.hide();

      // timer(1000).subscribe(() => this.showSplash = false);


      this.showedAlert = false;
    });

    var loc_id = JSON.parse(localStorage.getItem('user_data'));
    // console.log(  loc_id.length)
    if (loc_id) {
      if (loc_id.role != 'AGENT') {
        console.log("true");
        firebase.initializeApp(config);


        setTimeout(() => {
          // timer(1000).subscribe(() => this.showSplash = false);
          this.showSplash = false;
          this.rootPage = 'HomePage';
        }, 3000);


        // this.showSplash = false;
        // this.rootPage = 'HomePage';
        // this.rootPage = ProfilePage; 
        var requestOptions = {
          method: 'GET',
        };

        fetch("https://api.geoapify.com/v1/ipinfo?&apiKey=83400769335141dfaa7633dad23dfb74", requestOptions)
          .then(response => response.json())
          .then(result =>
            this.apiProvider.getCountryid(result.country.iso_code).subscribe((res: any) => {
              console.log(res.data);
              this.geo_country_id = res.data[0].country_id;
              if (!localStorage.getItem('geo_country_id')) {
                localStorage.setItem('geo_country_id', this.geo_country_id)
                localStorage.setItem('currency_country_id', this.geo_country_id);
              } else {

              }
            })

          )
          .catch(error => console.log('error', error));
      } else {
        setTimeout(() => {
          // timer(1000).subscribe(() => this.showSplash = false);
          this.showSplash = false;
          this.rootPage = 'AgenthomePage';
        }, 3000);
      }

    } else {
      console.log("false");
      // this.rootPage = TabsPage;


      // if(this.showSplash == false){

      // }

      // setTimeout(() => {
      // timer(1000).subscribe(() => this.showSplash = false);
      this.showSplash = false;
      this.rootPage = 'SignupPage';
      // }, 3000);




      this.http.get('https://api.ipify.org?format=json') // ...using post request '
        .subscribe((res: any) => {
          console.log('res ', res);
          this.ip_address = res.ip;
          localStorage.setItem('ip_address', this.ip_address)
          console.log(this.ip_address);
        });

    }

    if (this.platform.is('cordova')) {
      try {
        if (this.platform.is('android')) {
          this.oneSignal.startInit('4384a65c-4b5f-44c0-93cb-a5c49ce2d062', '641247358527');
          // this.oneSignal.startInit('onseSignalAppId', 'googleProjectId');
        }
        if (this.platform.is('ios')) {
          this.oneSignal.startInit('8feeda7c-5541-4e26-96a2-c66f843e5902');
        }
        this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.Notification);
        this.oneSignal.handleNotificationReceived().subscribe(() => {
          // do something when notification is received
        });
        this.oneSignal.handleNotificationOpened().subscribe(result => {
          // do something when a notification is opened
        });
        this.oneSignal.endInit();
        // Then You Can Get Devices ID
        this.oneSignal.getIds().then(identity => {
          // alert(identity.pushToken + " It's Push Token");
          // alert(identity.userId + " It's Devices ID");
          localStorage.setItem("player_id", identity.userId);
        });

      } catch (e) {

      }


    }


    this.platform.registerBackButtonAction(() => {
      // Catches the active view
      let nav = this.app.getActiveNavs()[0];
      let activeView = nav.getActive();
      // Checks if can go back before show up the alert
      if (activeView.name === 'HomePage') {
        if (nav.canGoBack()) {
          this.app.navPop();
        } else {
          const alert = this.alertCtrl.create({
            title: 'Oh No!',
            message: 'Are you sure you want to Exit?',
            mode: 'ios',
            buttons: [{
              text: 'No',
              role: 'cancel',
              handler: () => {
                this.nav.setRoot('HomePage');
                console.log('** Saída do App Cancelada! **');
              }
            }, {
              text: 'Yes',
              handler: () => {
                this.platform.exitApp();
                // localStorage.clear();
                // window.location.reload();
                // this.LogOut();
                // this.platform.exitApp();
              }
            }]
          });
          alert.present();
        }
      } else {
        this.app.navPop();
      }
    })


  }


  menuRadius() {
    setTimeout(() => {
      document.querySelector('ion-menu').shadowRoot.querySelector('.menu-inner').setAttribute('style', 'border-radius:0px 50px 0px 0px');
    }, 2000);
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot(page.component);
  }
  LogOut() {
    this.logOutAlert();
  }

  logOutAlert() {
    var usr_ph = localStorage.getItem('usr_ph');
    var usr_password = localStorage.getItem('usr_password');
    this.showedAlert = true;
    this.confirmAlert = this.alertCtrl.create({
      cssClass: 'my-custom-class',
      subTitle: 'Are you sure you want to Logout?',
      mode: 'ios',
      buttons: [{
        text: 'No',
        handler: () => {
        }
      }, {
        text: 'Ok',
        handler: () => {
          localStorage.clear();
          // window.location.reload();
          // localStorage.setItem("usr_ph", usr_ph);
          // localStorage.setItem("usr_password", usr_password);
          // this.nav.setRoot('SignupPage', { "sigmentstatus": "login" });
          localStorage.setItem("usr_ph", usr_ph);
          localStorage.setItem("usr_password", usr_password);
          this.nav.setRoot('SignupPage');
        }
      },
      ]
    });
    this.confirmAlert.present();
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts